import React from 'react'
import posed, { PoseGroup } from 'react-pose'
import styled from 'styled-components'

const ButtonPose = posed.button({
  open: {
    delayChildren: 200,
    staggerChildren: 50
  },
  closed: {
    delayChildren: 200,
    staggerChildren: 50
  },
  enter: {
    y: 0,
    opacity: 1
  },
  exit: {
    y: -20,
    opacity: 0
  },
  initialPose: 'closed'
});

const ButtonMenu = styled(ButtonPose)`
  position: absolute;
  top: 10px;
  right: 20px;
  display: block;
  width: 60px;
  height: 45px;
  cursor: pointer;
  z-index: 1000;
  @media (min-width: 1024px) {
    position: fixed;
  }
`

const ItemPose1 = posed.span({
  open: { x: 30, opacity: 0 },
  closed: { x: 0, opacity: 1 }
});

const ItemMenu1 = styled(ItemPose1)`
  display: inline-block;
  position: absolute;
  height: 5px;
  width: 40px;
  margin: 0;
  background: white;
  opacity: 1;
  left: 10px;
  padding: 0px;
  top: 20px;
`

const ItemPose2 = posed.span({
  open: { y: 10, rotate: 50 },
  closed: { y: 0, rotate: 0 }
});

const ItemMenu2 = styled(ItemPose2)`
  display: inline-block;
  position: absolute;
  height: 5px;
  width: 40px;
  margin: 0;
  background: white;
  opacity: 1;
  left: 10px;
  padding: 0px;
  top: 10px;
`

const ItemPose3 = posed.span({
  open: { y: -10, rotate: -50 },
  closed: { y: 0, rotate: 0 }
});

const ItemMenu3 = styled(ItemPose3)`
  display: inline-block;
  position: absolute;
  height: 5px;
  width: 40px;
  margin: 0;
  background: white;
  opacity: 1;
  left: 10px;
  padding: 0px;
  top: 30px;
`

class Button extends React.Component {
  state = { isVisible: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 1500);
  }

  render() {
    const { isVisible } = this.state;
    const { toggle, isOpen } = this.props;

    return(
      <PoseGroup>
        {isVisible
          ? <ButtonMenu aria-label="Menu" key={"sidebarButton"} pose={isOpen ? 'open' : 'closed'} onClick={toggle}>
              <ItemMenu1/>
              <ItemMenu2/>
              <ItemMenu3/>
            </ButtonMenu>
          : null}
      </PoseGroup>
    )
  }
}

export default Button
